import cookie from "js-cookie";
import moment from "moment";
class CookieUtils {
  static setCookie = (key, value, expDate) => {
    const nowDate = moment(Date.now());
    const toDate = moment(expDate);
    const diffDays = toDate.diff(nowDate, "days") + 1000;
    // const expDate = 4000;
    cookie.set(key, value, { expires: diffDays });
  };

  getCookie(key, req = {}) {
    if (typeof window !== "undefined") {
      return this.getCookieFromBrowser(key);
    } else {
      return this.getCookieFromServer(key, req);
    }
  }

  static removeCookie = (key) => {
    cookie.remove(key);
  };

  getCookieFromBrowser(key) {
    return cookie.get(key);
  }

  getCookieFromServer(key, req) {
    if (!req.headers) return;
    const { cookie } = req.headers;

    if (!cookie) return undefined;

    const rawCookie = cookie
      .split(";")
      .find((cookie) => cookie.trim().startsWith(`${key}=`));
    if (!rawCookie) return undefined;

    return rawCookie.split("=")[1];
  }
}

export default CookieUtils;
